// Legacy views copy grants into local UI flags. Keep those flags in sync on
// identity invalidation and successful retries, without starting more requests.
export default {
  watch: {
    '$store.state.group_permissions': {
      immediate: true,
      handler() {
        this.applyGroupPermissions();
      },
    },
  },
};
